import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { App } from './App';
import { DevelopmentMigration } from './pages/DevelopmentMigration';
import { Wine } from './pages/Wine';
import { ShopifyDesignDevelopment } from './pages/ShopifyDesignDevelopment';
import { About } from './pages/About';
import { Work } from './pages/Work';
import { Contact } from './pages/Contact';
import { ShopifyPOS } from './pages/ShopifyPOS';
import { DigitalWallet } from './pages/DigitalWallet';
import { WineryCalculator } from './pages/WineryCalculator';
export function AppRouter() {
  return <Routes data-id="element-11">
      <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
      <Route path="/designandbuild" element={<DevelopmentMigration data-id="element-15" />} data-id="element-14" />
      <Route path="/wine" element={<Wine data-id="element-17" />} data-id="element-16" />
      <Route path="/shopify-design-development" element={<ShopifyDesignDevelopment data-id="element-19" />} data-id="element-18" />
      <Route path="/shopify-pos" element={<ShopifyPOS data-id="element-21" />} data-id="element-20" />
      <Route path="/digital-wallet" element={<DigitalWallet data-id="element-23" />} data-id="element-22" />
      <Route path="/winery-calculator" element={<WineryCalculator data-id="element-25" />} data-id="element-24" />
      <Route path="/about" element={<About data-id="element-27" />} data-id="element-26" />
      <Route path="/work" element={<Work data-id="element-29" />} data-id="element-28" />
      <Route path="/contact" element={<Contact data-id="element-31" />} data-id="element-30" />
    </Routes>;
}